import bankStatement from './bankStatement';
import contacts from './contacts';
import cover from './cover';
import crossroad from './crossroad';
import debtors from './debtors';
import documents from './documents';
import footer from './footer';
import form from './form';
import formsApi from './formsApi';
import notFound from './notFound';
import offer from './offer';
import personInfo from './personInfo';
import personInfoLoanValue from './personInfoLoanValue';
import personInfoPersonData from './personInfoPersonData';
import stepper from './stepper';
import summary from './summary';
import thankYou from './thankYou';
import header from './header';

export default {
  title: 'Moje Comfort Money',
  logo: {
    alt: 'Logo Moje Comfort Money',
  },
  stepper,
  crossroad,
  debtors,
  personInfoLoanValue,
  personInfoPersonData,
  footer,
  form,
  contacts,
  summary,
  thankYou,
  bankStatement,
  cover,
  personInfo,
  documents,
  notFound,
  formsApi,
  offer,
  header,
};
